export const FileList = [
  {
    FileName: "ABC",
    PlanName: "Nairobi",
    PlanId: "1",
    PayDate: "11/03/2021",
    MapName: "Justin",
    Category: "New",
    FileTotal: 10000,
  },
  {
    FileName: "ABCD",
    PlanName: "Nairobi",
    PlanId: "1",
    PayDate: "19/03/2021",
    MapName: "Austin",
    Category: "Generated",
    FileTotal: 1000,
  },
  {
    FileName: "PQR",
    PlanName: "Nairobi",
    PlanId: "1",
    PayDate: "03/03/2021",
    MapName: "Augustin",
    Category: "Generated",
    FileTotal: 20000,
  },
  {
    FileName: "STU",
    PlanName: "Berlin",
    PlanId: "3",
    PayDate: "06/08/2021",
    MapName: "Constantin",
    Category: "New",
    FileTotal: 10000,
  },
  {
    FileName: "JKL",
    PlanName: "Berlin",
    PlanId: "3",
    PayDate: "16/08/2021",
    MapName: "Justin",
    Category: "New",
    FileTotal: 12000,
  },
  {
    FileName: "QWE",
    PlanName: "Denver",
    PlanId: "2",
    PayDate: "09/09/2021",
    MapName: "Justin",
    Category: "Generated",
    FileTotal: 10000,
  },
];

export const planNames = [
  {
    label: "Nairobi",
    value: "1",
  },
  {
    label: "Denver",
    value: "2",
  },
  {
    label: "Berlin",
    value: "3",
  },
  {
    label: "Tokyo",
    value: "4",
  },
];
